// services/candidatureService.ts
import axios from "axios";
import { BaseCandidature, Candidature } from "../types/features/Candidature";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const candidatureService = {
  // 🔓 PUBLIC - Tout le monde peut postuler (pas de token)
  async create(formData: BaseCandidature): Promise<Candidature> {
    const response = await axios.post(`${MAIN_API_URL}/candidatures`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async getAll(token: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Candidature>> {
    const response = await axios.get(`${MAIN_API_URL}/candidatures`, {
      params: { page, per_page: perPage },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async getById(token: string, id: string): Promise<Candidature> {
    const response = await axios.get(`${MAIN_API_URL}/candidatures/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async getByProductName(
    token: string,
    productName: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Candidature>> {
    const response = await axios.get(`${MAIN_API_URL}/candidatures/product/${productName}`, {
      params: { page, per_page: perPage },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async getByJobOffer(
    token: string,
    jobOfferId: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Candidature>> {
    const response = await axios.get(`${MAIN_API_URL}/candidatures/job-offer/${jobOfferId}`, {
      params: { page, per_page: perPage },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async update(token: string, id: string, data: { status: string; notes?: string }): Promise<Candidature> {
    const response = await axios.put(`${MAIN_API_URL}/candidatures/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async delete(token: string, id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/candidatures/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // 🔒 PROTÉGÉ - Token requis (admin uniquement)
  async deleteMany(token: string, ids: string[]): Promise<void> {
    const promises = ids.map((id) => this.delete(token, id));
    await Promise.all(promises);
  },

  // 🔓 PUBLIC - Téléchargement public (le CV est public)
  async downloadCV(path: string): Promise<void> {
    window.open(`${MAIN_API_URL}/candidatures/download?path=${path}`, "_blank");
  },
};